<template>
  <v-chip
    v-if="scheduled"
    x-small
    color="indigo lighten-4"
    text-color="indigo darken-2"
    class="motion-incident-monitoring"
  >
    Monitoring
  </v-chip>
  <v-btn
    v-else-if="hasIncident"
    color="amber lighten-3"
    depressed
    small
    tile
    title="View Incident"
    @click="$emit('resolve')"
  >
    <v-icon left small>fas fa-exclamation-triangle</v-icon>
    Resolve
  </v-btn>
</template>

<script>
export default {
  name: "MotionIncidentIndicator",
  props: {
    scheduled: {
      type: Boolean,
      default: false,
    },
    hasIncident: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
